import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import { CssBaseline, Box } from '@mui/material'
import theme from './theme'
import { AuthProvider } from './contexts/AuthContext'
import { PoolProvider } from './contexts/PoolContext'
import ProtectedRoute from './components/Auth/ProtectedRoute'
import ErrorBoundary from './components/Common/ErrorBoundary'
import Login from './components/Auth/Login'
import Dashboard from './pages/Dashboard'
import PoolManagement from './pages/PoolManagement'
import AddMeasurement from './pages/AddMeasurement'
import AddChemicals from './pages/AddChemicals'
import History from './pages/History'

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <PoolProvider>
          <Router>
            <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
              <ErrorBoundary>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/pools"
                  element={
                    <ProtectedRoute>
                      <PoolManagement />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/add-measurement"
                  element={
                    <ProtectedRoute>
                      <AddMeasurement />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/add-chemicals"
                  element={
                    <ProtectedRoute>
                      <AddChemicals />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/history"
                  element={
                    <ProtectedRoute>
                      <History />
                    </ProtectedRoute>
                  }
                />
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
              </ErrorBoundary>
            </Box>
          </Router>
        </PoolProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
